//Allowed characters (Latin, space, hyphen, apostrophe)
export const LATIN_TEXT_PATTERN = /[^A-Za-z\s'-.àáâäæãåāăąçćčďđèéêëēėęěğǵḧîïíīįıłḿñǹńňôöòóœøōõőṕŕřśšşťțûüùúūǘůűųẃẍÿýžźżÀÁÂÄÆÃÅĀĂĄÇĆČĎĐÈÉÊËĒĖĘĚĞĠḦÎÏÍĪĮİŁḾÑǸŃŇÔÖÒÓŒØŌÕŐṔŔŘŚŠŞŤȚÛÜÙÚŪǗŮŰŲẂẌŸÝŽŹŻ]/g;
//Repeating spaces, hyphens, apostrophes
export const DUPLICATE_SYMBOLS_PATTERN = /(['\-\s])\1+/g;
//Spaces, hyphens, apostrophes at the beginning and end of a line
export const OUTER_EDGES_PATTERN = /^[\s'-]+|[\s'-]+$/g;
//Check: Does it contain invalid characters?
export const HAS_ILLEGAL_SYMBOLS_PATTERN = /[^A-Za-z\s'-.]/;
//Removing all non-digits
export const NON_DiGIT_PATTERN = /\D/g;
//Check: the string consists only of numbers
export const DIGITS_ONLY_PATTERN = /^\d*$/;
//Protocol (http/https) at the beginning of the line
export const URL_PROTOCOL_PATTERN = /^https?:\/\//i;
//The line starts with www.
export const URL_STARTS_WITH_WWW_PATTERN = /^www\./i;
//Looks like a domain (eg: google.com)
export const URL_LOOKS_LIKE_DOMAIN_PATTERN = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
//Simple Regular Expression for URL-like Strings
export const SIMPLE_URL_VALIDATION_PATTERN = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+%,;=]*)?$/;
//Only numbers and symbols
export const NUMBERS_AND_SYMBOLS_PATTERN = /^[0-9\s\-_.]+$/i;
export const CYRILLIC_PATTERN = /[а-яА-ЯёЁ]/g;
//The allowed character set for the username is letters/digits/_/./-. The length "with a reserve" is up to 30 characters (typical for a Twitter handle)
export const USER_RE = /^[A-Za-z0-9._-]{1,30}$/;
//The allowed character set for the username is letters/digits/_/./-. The length "with a reserve" is up to 100 characters (typical for a LinkedIn/Facebook)
export const SLUG_RE = /^[A-Za-z0-9._-]{1,100}$/;
// Regular expression for validating phone numbers
export const PHONE_RE = /^\+?[0-9]{10,12}$/;
export const ONLY_ALLOWED = /[^A-Za-z0-9 '\-’—]/g;
// Prohibited schemes (XSS protection)
export const UNSAFE_URL_PATTERN = /^(java|data|vbsscript):/i;
// проверка наличия протокола (http, https, ftp, mailto, etc.)
export const URL_WITH_PROTOCOL_PATTERN = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//;
export const BAD_VALUE_RE =/\b(n\/a|null|undefined)\b/i;
export const BAD_CITY_RE = /^\s*no\s*city\b/i;
export const HOUSE_NUMBER_RE =/\b\d{1,4}[A-Za-z]?\b/;
export const INDEX_ADDRESS_RE =/\b[A-Za-z]\d{1,3}\b/;

